import produce from 'immer';
import { INIT_KEYCLOCK } from './constants';
import { InitKeycloakSuccessActionTypes, IInitKeycloakState } from './types';

const initialState: IInitKeycloakState = {
  isInitilization: false,
};

export default produce(
  (
    draft = initialState,
    action: InitKeycloakSuccessActionTypes,
  ): IInitKeycloakState => {
    switch (action.type) {
      case INIT_KEYCLOCK: {
        draft.isInitilization = true;
        break;
      }
      default:
        return draft;
    }
  },
);
